module.exports = __webpack_public_path__ + "static/media/logoaltasalud.8294d8f7.jpg";